import { render, staticRenderFns } from "./dialogComponent.vue?vue&type=template&id=aeb162d4&scoped=true"
import script from "./dialogComponent.vue?vue&type=script&lang=ts"
export * from "./dialogComponent.vue?vue&type=script&lang=ts"
import style0 from "./dialogComponent.vue?vue&type=style&index=0&id=aeb162d4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aeb162d4",
  null
  
)

export default component.exports